import { render, staticRenderFns } from "./SnsPostItemContentsParts.vue?vue&type=template&id=51608b4c&scoped=true"
import script from "./SnsPostItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./SnsPostItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./SnsPostItemContentsParts.vue?vue&type=style&index=0&id=51608b4c&prod&lang=scss&scoped=true"
import style1 from "./SnsPostItemContentsParts.vue?vue&type=style&index=1&id=51608b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51608b4c",
  null
  
)

export default component.exports